import { objectMap } from './../../utils/object'
import { FETCH_USER_STATS_SUCCESS } from './Stats.actions'

const INITIAL_STATE = {
  postCreate: 0,
  readsGot: 0,
  commentsGot: 0,
}

export const userStatsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USER_STATS_SUCCESS:
      /*
       This is guarding us against responses that are lower than 0
       (for some users this is the cases ¯\_(ツ)_/¯ )
       */
      const newState = objectMap(action.response, (stat, amount) => {
        let statAsInt = {}
        statAsInt[stat] = isNaN(amount) || parseInt(amount, 10) < 0 ? 0 : parseInt(amount, 10)
        return statAsInt
      })

      return { ...state, ...newState }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/userStats/Stats.reducers.js